function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProHeader = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _ScreenBackgroundImage = require("../ScreenBackgroundImage");
var _Header = require("../Header");
var _View = require("../View");
var _Heading = require("../Heading");
var _SvgImage = require("../SvgImage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["backgroundImage", "logoImage", "logoLabel", "name", "useFallbackLogo", "fallbackLogoImage", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ProHeader = exports.ProHeader = (0, _react.memo)(function (_ref) {
  var backgroundImage = _ref.backgroundImage,
    logoImage = _ref.logoImage,
    logoLabel = _ref.logoLabel,
    name = _ref.name,
    _ref$useFallbackLogo = _ref.useFallbackLogo,
    useFallbackLogo = _ref$useFallbackLogo === void 0 ? true : _ref$useFallbackLogo,
    fallbackLogoImage = _ref.fallbackLogoImage,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var hasBackgroundImage = !!(backgroundImage != null && backgroundImage.uri);
  var hasLogo = !!(logoImage != null && logoImage.uri);
  var hasName = !!name;
  var fallbackLogoSource = fallbackLogoImage || (0, _jsxRuntime.jsx)(_SvgImage.SvgImage, {
    image: require("../../images/Workplace.svg")
  });
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_Header.Header, Object.assign({
      testID: "proHeader",
      backgroundImage: hasBackgroundImage ? (0, _jsxRuntime.jsx)(_reactNative.ImageBackground, {
        style: styles.proHeaderImage,
        source: backgroundImage,
        testID: "proHeaderImage",
        resizeMode: "cover"
      }) : (0, _jsxRuntime.jsx)(_ScreenBackgroundImage.ScreenBackgroundImage, {
        color1: "#F28E84",
        color2: "#E26F63"
      }),
      style: [styles.header, style],
      contentStyle: styles.headerContent
    }, props, {
      children: hasLogo ? (0, _jsxRuntime.jsx)(_View.View, {
        style: styles.logo,
        testID: "proHeaderLogo",
        children: (0, _jsxRuntime.jsx)(_reactNative.Image, {
          source: logoImage,
          accessibilityLabel: logoLabel,
          style: styles.logoImage
        })
      }) : useFallbackLogo && (0, _jsxRuntime.jsx)(_View.View, {
        style: styles.logo,
        children: (0, _jsxRuntime.jsx)(_View.View, {
          style: styles.logoImage,
          children: fallbackLogoSource
        })
      })
    })), hasName && (0, _jsxRuntime.jsx)(_View.View, {
      style: styles.nameContainer,
      children: (0, _jsxRuntime.jsx)(_Heading.Heading, {
        level: 1,
        style: styles.name,
        children: _reactNative.Platform.OS === 'web' ? (0, _jsxRuntime.jsx)("span", {
          translate: "no",
          children: name
        }) : name
      })
    })]
  });
});